import { WearablesEntity } from "./wearables.entities";
import { calculateParticipantRowMetrics, calculateRowMetrics, dialogMetricColumnDefs, EmptyMetric, metricColumnDefs } from "./wearables.functions";
import { WearablesLookup } from "./wearables.lookup";

export class WearablesDemographicsTab {

    wearablesData: WearablesEntity[];

    tableSelector: string;
    table: any;
    dialogTable: any;

    selectedAppendixIds = [];
    selectedSiteIds = [];

    constructor(tableSelector: string, wearablesData: WearablesEntity[]) {
        this.tableSelector = tableSelector;
        this.wearablesData = wearablesData;
    }

    initializeTable() {
        this.table = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            fixedHeader: true,
            orderFixed: [1, 'asc'],
            rowGroup: {
                dataSrc: ['demographicGroup'],
                startClassName: 'demographic-group',
            },
            columns: [
                // { data:'platform', title: 'Platform', className: 'text-left font-size12 nowrap' },
                // { visible:false, data:'trial', title: 'Trial', className: 'text-left font-size12 nowrap' },
                { visible:false, data:'demographicGroup', title: '', className: 'text-left font-size12 nowrap' },
                { visible:false, data:'demographicGroupSortId', title: '', className: 'text-left font-size12 nowrap' },
                { data:'demographicValue', title: 'Demographic', className: 'text-left font-size12 nowrap' },
                { data:'totalParticipants', title: 'Total<br>Participants', className: 'text-center font-size12 nowrap last-fixed' },
                ...metricColumnDefs,
            ]
        });

        $(this.tableSelector).on('click', 'tr', this, function (evt) {
            const row = $(evt.data.tableSelector).DataTable().row(this).data();
            if (row) {
                evt.data.showDialog(
                    evt.data.selectedAppendixIds,
                    evt.data.selectedSiteIds,
                    row.demographicProperty,
                    row.demographicId,
                    row.demographicGroup,
                    row.demographicValue
                );
            }
        });

        this.initializeDialog();
    }

    updateData(filter) {
        if (!filter) return;

        this.selectedAppendixIds = filter.selectedAppendixIds;
        this.selectedSiteIds = filter.selectedSiteIds;

        const rows = [];

        const filteredData = this.wearablesData.filter((w) => (filter.selectedAppendixIds.includes(w.AppendixId) && (filter.selectedSiteIds.includes(w.SiteNumber))));

        // Race
        for (let i = 0; i <= 7; i++) {
            const group = filteredData.filter((w) => w.RaceId === i);

            const metrics = calculateRowMetrics(group);
            rows.push({
                demographicGroup: `Race`,
                demographicGroupSortId: 0,
                demographicValue: WearablesLookup.GetRace(i),
                demographicProperty: 'RaceId',
                demographicId: i,
                totalParticipants: metrics.totalParticipants,
                ...metrics,
            });
        }

        // Age
        for (let i = 0; i <= 3; i++) {
            const group = filteredData.filter((w) => w.AgeRange === i);

            const metrics = calculateRowMetrics(group);
            rows.push({
                demographicGroup: `Age Range`,
                demographicGroupSortId: 5,
                demographicValue: WearablesLookup.GetAgeGroup(i),
                demographicProperty: 'AgeRange',
                demographicId: i,
                totalParticipants: metrics.totalParticipants,
                ...metrics,
            });
        }

        // Sex
        for (let i = 0; i <= 4; i++) {
            const group = filteredData.filter((w) => w.SexId === i);

            const metrics = calculateRowMetrics(group);
            rows.push({
                demographicGroup: `Sex`,
                demographicGroupSortId: 4,
                demographicValue: WearablesLookup.GetSex(i),
                demographicProperty: 'SexId',
                demographicId: i,
                totalParticipants: metrics.totalParticipants,
                ...metrics,
            });
        }

        // Hispanic
        for (let i = 0; i <= 2; i++) {
            const group = filteredData.filter((w) => w.HispanicId === i);

            const metrics = calculateRowMetrics(group);
            rows.push({
                demographicGroup: `Ethnicity`,
                demographicGroupSortId: 2,
                demographicValue: WearablesLookup.GetEthnicity(i),
                demographicProperty: 'HispanicId',
                demographicId: i,
                totalParticipants: metrics.totalParticipants,
                ...metrics,
            });
        }

        this.table.clear();
        this.table.rows.add(rows).draw();
    }

    refresh() {
        this.table.draw();
    }

    initializeDialog() {
        this.dialogTable = $('#dialog-demo-details-table').DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 3
            },
            columns: [
                // { data:'platform', title: 'Platform', className: 'text-left font-size12 nowrap' },
                { data:'trial', title: 'Trial', className: 'text-left font-size12 nowrap' },
                { data:'participantId', title: 'Participant', className: 'text-center font-size12 nowrap' },
                ...dialogMetricColumnDefs
            ]
        });

        $('#demo-details-modal').on('shown.bs.modal', () => {
            this.dialogTable.draw();
        });
    }

    showDialog(appendices, sites, demoProp, demoId, demoGroup, demoValue) {
        const participants = this.wearablesData
            .filter((w) => (
                appendices.includes(w.AppendixId)
                && (sites.includes(w.SiteNumber))
                && (w[demoProp] === demoId)
            ))
            .map((p) => calculateParticipantRowMetrics(p));

        this.dialogTable.clear();
        this.dialogTable.rows.add(participants).draw();

        $('#demo-details-modal-title').text(`${demoGroup} - ${demoValue}`);
        $('#demo-details-modal').modal('show');
    }

}